// extracted by mini-css-extract-plugin
export var active = "_6q-c";
export var activeIndicator = "_6q-7";
export var animate = "_6q-b";
export var contentWidthTabs = "_6q-5";
export var disabled = "_6q-d";
export var flat = "_6q-1";
export var fullWidth = "_6q-3";
export var lg = "_6q-a";
export var md = "_6q-9";
export var redoButtonTabGroup = "_6q-0";
export var sm = "_6q-8";
export var tabButton = "_6q-4";
export var tabButtonsContainer = "_6q-2";
export var xs = "_6q-6";